import { GetStaticPaths } from 'next';
import _ from 'lodash';
import {
  fetchCategory,
  fetchStaticFilters,
  ProductsListingPage,
  fetchProductsCategoriesData,
  searchStaticProducts,
} from 'src/modules/products';
import fs from 'fs';
import filterPathsListWithOutputChannel from 'src/utils/filterPathsListWithOutputChannel';

type Path = { params: { category?: string; slug?: string }; locale: 'en' | 'de' };

export const getStaticPaths: GetStaticPaths = async () => {
  const categories = await fetchProductsCategoriesData();
  const paths: Path[] = [];

  _.each(categories, (category) => {
    paths.push({
      params: { category: category.slug },
      locale: 'en',
    });
    paths.push({
      params: { category: category.slug },
      locale: 'de',
    });
  });

  const pathsList = filterPathsListWithOutputChannel(
    _.map(paths, (p) => `${p.locale}/products/${p.params.category}`)
  );

  fs.writeFileSync(
    './public/data/paths/products_category.json',
    JSON.stringify(pathsList, null, 2)
  );

  return { paths: [], fallback: true };
};

export async function getStaticProps({ params, locale }) {
  const categorySlug = params.category as string;

  // console.log('getStaticProps, params=', params);
  // console.log('getStaticProps, rest=', rest);

  const data = await Promise.allSettled([
    fetchCategory({ categorySlug }),
    fetchStaticFilters(categorySlug),
    searchStaticProducts({
      categorySlug: categorySlug as string,
      locale: locale,
      filters: { productSubcategories: [], designers: [], locationTypes: [] },
      pagination: { offset: 0, limit: 100 },
      sortColumn: 'ranking',
    }),
  ]);

  // @ts-ignore TODO fix type
  const productCategory = data[0]?.value;
  // @ts-ignore TODO fix type
  const filterData = data[1]?.value;
  // @ts-ignore TODO fix type
  const products = data[2]?.value;
  return { props: { productCategory, filterData, ...products } };
}

export default ProductsListingPage;
